import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListOption } from '../../../../modules/tcm-core.module';
import { Subscription } from 'rxjs/internal/Subscription';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { EquipmentLinkedSearchRequest, EquipmentLinkedSearchResponse } from '../../../../models/serialized-items';
import { BaseSecureSearch } from '../../../../modules/tcm-common';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { ListOptionService } from '../../../../services/list-option.service';
import { TranslationService } from '../../../../services/translation.service';
import { PatientDataService, PermissionsService } from '../../../../services';
import { SpecialActionAccesses } from '../../../../models/roles';
import { NullObjectSpecialActions } from '../../../../modules/tcm-common/security/null-object-special-actions';

@Component({
    selector: 'patient-equipment-widget-search',
    templateUrl: './patient-equipment-widget-search.component.html',
    styleUrls: ['./patient-equipment-widget-search.component.scss'],
    standalone: false
})
export class PatientEquipmentWidgetLinkedSearchComponent extends BaseSecureSearch<EquipmentLinkedSearchRequest, EquipmentLinkedSearchResponse> {

  private refreshSubscription: Subscription;
  private patientStatusChangedSubscription: Subscription;

  public showAdvanced: boolean;
  public serializedItemStatusTranslations: any;
  public serializedItemStatusOptions: ListOption<number>[];
  private equipmentselection: Array<any> = [];
  override get specialActionPermissions(): SpecialActionAccesses {
    return this.permissionService.currentPermissions
      ? this.permissionService.currentPermissions.specialActions
      : NullObjectSpecialActions.specialActions;
  }
  constructor(protected override componentContext: SecureBaseComponentContext,
    protected override route: ActivatedRoute,
    private listOptionService: ListOptionService,
    private translationService: TranslationService,
    private patientService: PatientDataService, private permissionService: PermissionsService) {
    super(componentContext, route);
    this.actionName = 'PatientWidget/EquipmentLinkedSearch';
    this.serializedItemStatusTranslations = this.translationService.getSerializedItemStatusTranslations();
    this.serializedItemStatusOptions = this.listOptionService.getSerializedItemStatusOptions();
    this.refreshSubscription = this.componentContext.broadcastService.getEvents(BroadCastEvents.SerializedItemChanged).subscribe(() => { this.refresh(); });
  }

  public get isAnyEquipmentSelected() {
    return this.equipmentselection.length > 0;
  }

  public override onFilterCleared() {
    this.requestModel.productGroupId = null;
    this.requestModel.status = null;
  }
  
  
  checkIfAllSelected(event: any, data: any) {
    if (event.target.checked) {

      if (data.productOrientation == "") {
        event.target.checked = false;
      }
      else {
        this.equipmentselection.push({ id: data.id, productOrientation: data.productOrientation });
        if (data.productOrientation == "Right") {
          if (this.equipmentselection.filter(p => p.productOrientation == "Right").length > 1) {
            event.target.checked = false;
          }
        }
        if (data.productOrientation == "Left") {
          if (this.equipmentselection.filter(p => p.productOrientation == "Left").length > 1) {
            event.target.checked = false;
          }
        }
      }
    }
    else {
      this.equipmentselection = this.equipmentselection.filter(p => p.productOrientation != data.productOrientation);
    }
    }

  public async updateLatest() {
    this.isLoading = true;

    var RightEquipment = null;
    var LeftEquipment = null;
    for (const value of this.equipmentselection) {
      if (value.productOrientation == "Left")
        LeftEquipment = value.id;
      if (value.productOrientation == "Right")
        RightEquipment = value.id;
    }
    await this.patientService.updateLatest(RightEquipment, LeftEquipment, this.requestModel.patientId, this.componentCancellationTokenSource.promise());
    this.componentContext.broadcastService.next({ name: BroadCastEvents.PatientEquipmentChanged });
     
this.back();
    this.isLoading = false;
  }

  

  protected override createRequestModel() {
    const request = super.createRequestModel();
    request.productGroupId = null;
    request.status = null;

    return request as any;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
